import { WorkatoJWT } from '../../services/platform-workato-jwt';
//import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';

//const clientId = '39570214630-1ucdra019t24p3fv94rkn45ee2c2uqau.apps.googleusercontent.com';
//const redirectUri = 'http://localhost:3000';

// Client ID
// 39570214630-1ucdra019t24p3fv94rkn45ee2c2uqau.apps.googleusercontent.com
// Client secret
// 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

const CardWorkatoConnector = ({ connectionName, connectionId }) => {
  const jwtData = WorkatoJWT();

  return (
    <>
      {/* <GoogleOAuthProvider clientId={clientId} redirectUri={redirectUri}>
        <div>
          <GoogleLogin>
            <button>Sign in with Google</button>
          </GoogleLogin>
        </div>
      </GoogleOAuthProvider> */}
      {connectionId && jwtData ? (
        <div className="box-white">
          <h3 className="text-primary text-center text-mid mb-4 mt-4">{connectionName}</h3>
          <iframe
            title="workato"
            src={`https://www.workato.com/direct_link/embedded/connections/${connectionId}?workato_dl_token=${jwtData}`}
            width="100%"
            height="320"
          />
        </div>
      ) : null}
    </>
  );
};

export { CardWorkatoConnector };
